import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { ErrorSummary } from '@digdir/designsystemet-react';

import { ErrorGroupWrapper } from '../formErrors/styledComponents';
import { useOppvarmingFormContext } from '../../utils';
import { ErrorLinkItem } from '../formErrors/errorLinkItem';

export const SolfangerErrorSummary = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.solfanger' });

  const errors = formState.errors?.solfanger?.value;

  if (!errors) {
    return null;
  }

  return (
    <Fragment>
      <ErrorGroupWrapper>
        <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
        <ErrorSummary.List>
          <ErrorLinkItem error={errors?.varmesentral?.installasjonsAr} />
          <ErrorLinkItem error={errors?.varmesentral?.vetInstallasjonsAr} />
          <ErrorLinkItem error={errors?.varmesentral?.varmesentralType} />
          <ErrorLinkItem error={errors?.varmesentral?.installertIOppvarmetRom} />
          <ErrorLinkItem error={errors?.installasjonsAr} />
          <ErrorLinkItem error={errors?.vetInstallasjonsAr} />
          <ErrorLinkItem error={errors?.serviceGjennomfortSiste2Ar} />
          <ErrorLinkItem error={errors?.bruk?.romoppvarming} />
          <ErrorLinkItem error={errors?.radiator?.selected} />
          <ErrorLinkItem error={errors?.radiator?.value?.termostatstyring} />
          <ErrorLinkItem error={errors?.gulvvarme?.value?.termostatstyring} />
        </ErrorSummary.List>
      </ErrorGroupWrapper>
    </Fragment>
  );
};
